// File: src/config/FilterConfig.js

export const FILTER_CONFIG = [
  {
    fieldName: "demographic_category_01",
    jsonKey: "demographic_category_01",
    displayName: "Location",
  },
  {
    fieldName: "demographic_category_02",
    jsonKey: "demographic_category_02",
    displayName: "Department",
  },
  {
    fieldName: "demographic_category_03",
    jsonKey: "demographic_category_03",
    displayName: "Functional Area",
  },
  {
    fieldName: "demographic_category_04",
    jsonKey: "demographic_category_04",
    displayName: "Job Classification",
    sortOrder: [
      "Job Classification 01",
      "Job Classification 02",
      "Job Classification 03",
      "Job Classification 04",
      "Job Classification 05",
      "Job Classification 06",
      "Job Classification 07",
      "Job Classification 08",
      "Job Classification 09",
      "Job Classification 10",
      "No Response",
    ],
  },
  {
    fieldName: "demographic_category_05",
    jsonKey: "demographic_category_05",
    displayName: "Tenure",
    sortOrder: [
      "Less than 1 year",
      "1 to 2 years",
      "3 to 5 years",
      "6 to 10 years",
      "11 to 19 years",
      "20 years or more",
      "No Response",
    ],
  },
  {
    fieldName: "demographic_category_06",
    jsonKey: "demographic_category_06",
    displayName: "Generation",
    sortOrder: [
      "Traditionalists",
      "Baby Boomers",
      "Generation X",
      "Millennials",
      "Generation Z",
      "No Response",
    ],
  },
  {
    fieldName: "demographic_category_07",
    jsonKey: "demographic_category_07",
    displayName: "Gender",
    sortOrder: ["Female", "Male", "Non-Binary/Unspecified", "No Response"],
  },
  {
    fieldName: "demographic_category_08",
    jsonKey: "demographic_category_08",
    displayName: "Manager",
  },
  {
    fieldName: "demographic_category_09",
    jsonKey: "demographic_category_09",
    displayName: "Race",
  },
  {
    fieldName: "demographic_category_10",
    jsonKey: "demographic_category_10",
    displayName: "Employee Type",
  },
  // { fieldName: 'survey_id', jsonKey: 'survey_id', displayName: 'Survey Year' }
];
